export const GLOBAL_ERROR_CODE = {
  FAILED: 1,
  TRAIL_ENDED: 900,
  INVOICE_OCR_LIMIT: 2,
  ORDER_FORM_OCR_LIMIT: 5,
  TEMPLATE_OCR_LIMIT: 3,
  GENERAL_OCR_LIMIT: 4,
  IP_RESTRICTION: 950,
} as const

export type TrailEndedStatus = typeof GLOBAL_ERROR_CODE.TRAIL_ENDED
export type InvoiceOcrLimitStatus = typeof GLOBAL_ERROR_CODE.INVOICE_OCR_LIMIT
export type OrderFromOcrLimitStatus =
  typeof GLOBAL_ERROR_CODE.ORDER_FORM_OCR_LIMIT
export type TemplateOcrLimitStatus = typeof GLOBAL_ERROR_CODE.TEMPLATE_OCR_LIMIT
export type TrailApiLimitStatus =
  | InvoiceOcrLimitStatus
  | TemplateOcrLimitStatus
  | OrderFromOcrLimitStatus
export type TrailErrorStatus = TrailEndedStatus | TrailApiLimitStatus

export function isTrailApiLimitStatus(status: number) {
  return (
    [
      GLOBAL_ERROR_CODE.INVOICE_OCR_LIMIT,
      GLOBAL_ERROR_CODE.ORDER_FORM_OCR_LIMIT,
      GLOBAL_ERROR_CODE.TEMPLATE_OCR_LIMIT,
      GLOBAL_ERROR_CODE.GENERAL_OCR_LIMIT,
    ] as number[]
  ).includes(status)
}
